<template>
    <div v-if="copyNode">
        <label for="optionGroup-title">OptionGroup Title:</label>
        <b-form-input
            id="optionGroup-title"
            v-model="copyNode.title"
            :state="nameState"
            aria-describedby="input-live-help input-live-feedback"
            placeholder="Enter your name"
            trim/>
        <b-form-invalid-feedback id="input-live-feedback">
            Enter at least 3 letters
        </b-form-invalid-feedback>

        <b-row class="mt-2">
            <b-col md="6">
                <label for="choiceMin">Minimum Choice:</label>
                <b-form-select id="choiceMin"
                    v-model="copyNode.choiceMin"
                    :state="choiceValidate"
                    :options="optionsMin" />
            </b-col>
            <b-col md="6">
                <label for="choiceMax">Maximum Choice:</label>
                <b-form-select id="choiceMax"
                    v-model="copyNode.choiceMax"
                    :state="choiceValidate"
                    :options="optionsMax" />
            </b-col>
        </b-row>
        <b-form-invalid-feedback :state="choiceValidate">Wrong Choice</b-form-invalid-feedback>

        <b-form-checkbox
            class="mt-2"
            id="copyDuplicate"
            v-model="copyNode.duplicates"
            name="copyDuplicate"
            value="true"
            unchecked-value="false">
            Duplicate Ok
        </b-form-checkbox>
        
        <b-button size="sm" 
                  class="my-2 float-right"
                  variant="outline-primary"
                  @click="onSubmit"
                  :disabled="!nameState || !choiceValidate">Submit</b-button>
        <b-button size="sm" 
                  class="m-2 float-right"
                  variant="outline-danger"
                  @click="$emit('onCancel')">Cancel</b-button>
    </div>
</template>

<script>
export default {
    name : 'TreeMenuOptionGroup',
    props : ['node'],
    data() { 
        return { 
            copyNode : null,
            optionsMin : Array.apply(null, Array(10)).map((val, idx) => idx),
            optionsMax : Array.apply(null, Array(10)).map((val, idx) => idx + 1)
        }
    },
    computed : {
        nameState() {
            return this.copyNode && this.copyNode.title && this.copyNode.title.length > 2 ? true : false
        },
        choiceValidate() {
            return this.copyNode.choiceMin <= this.copyNode.choiceMax;
        }
    },
    watch : {
        node : {
            deep: true,
            handler(newValue) {
                if(newValue.method === "addChild") {
                    this.copyNode = { title : "" , choiceMin : 0, choiceMax : 1 , options : [] }
                } else {
                    this.copyNode = this.$deepCopy(newValue.node);
                }
            }
        }
    },
    created() { 
        if(this.node.method === "addChild") {
            this.copyNode = { title : "" , choiceMin : 0, choiceMax : 1 , options : [] }
        } else {
            this.copyNode = this.$deepCopy(this.node.node); 
        }
    },
    destroyed() { },
    methods: { 
        onSubmit() {
            this.$emit("onSubmit", this.copyNode)
        }
    },
}
</script>

<style scoped lang="scss">

</style>